export default __webpack_public_path__ + "static/media/opel_offer1.1ab5b72e.jpg";